import React from 'react';
import DraggableComponent from './DraggableComponent';
import { getUiVolume } from '../services/VolumeService';

/**
 * Button - A true extension of DraggableComponent using HOC pattern
 * 
 * This component extends DraggableComponent with proper inheritance semantics,
 * meaning it gets ALL of DraggableComponent's functionality:
 * - Toggle state management
 * - Drag and resize behavior  
 * - Long press selection
 * - Short press actions
 * - All internal state and methods
 * 
 * Plus button-specific enhancements.
 */
const Button = (props) => {

  // Custom handler to piggyback caption speech
  const { captionTextProcessorService } = require('../services/CaptionTextProcessorService');

  const handleButtonAction = (componentId, event, componentObj) => {
    console.log('🔘 Button action triggered');
    console.log(props.canvasProperties?.openCaptioning ? '✅ openCaptioning is enabled' : '❌ openCaptioning is disabled');
    const comp = componentObj || buttonComponent;
    console.log(comp?.accessibility?.captionText ? `✅ Caption text found: "${comp.accessibility.captionText.trim()}"` : '❌ No caption text found');
    // Check for open captioning and caption text
    if (comp?.accessibility?.captionText) {
      const rawText = comp.accessibility.captionText.trim();
      const processedText = captionTextProcessorService.processCaptionText(rawText);
      if (processedText) {
        // Display the caption in the UI Builder
        if (props.canvasProperties?.openCaptioning && typeof props.setCaptionText === 'function') {
          console.log(`📝 Setting caption text: "${processedText}"`);
          props.setCaptionText(processedText);
        }
        if (props.canvasProperties?.touchAudioLabels) {
          console.log(`🗣️ Speaking caption: "${processedText}"`);
          const utterance = new window.SpeechSynthesisUtterance(processedText);
          let volume = getUiVolume();
          console.log(`🔊 Using UI volume level: ${volume}`);
          utterance.volume = volume;
          window.speechSynthesis.speak(utterance);
        }
      } else {
        console.warn('⚠️ Caption text is empty, nothing to speak');
      }
    }
    // Call the original onAction if provided
    if (typeof props.onAction === 'function') {
      props.onAction(componentId, event, comp);
    }
  };

  // Ensure component is treated as a button but preserve all original data
  const buttonComponent = {
    ...props.component,
    type: 'button'
  };

  // Button inherits ALL DraggableComponent functionality
  // by passing through all props and letting DraggableComponent handle everything
  return (
    <DraggableComponent
      {...props}
      component={buttonComponent}
      onAction={handleButtonAction}
    />
  );
};

export default Button;
